import { defineComponent as _defineComponent } from 'vue';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import DataTable from '@/Components/DataTable.vue';
import Column from 'primevue/column';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import { ref } from 'vue';
import { formatISODate } from '@/Services/Utils';
import { useMitt } from '@/Plugins/mitt';
import { useSpinner } from '@/Plugins/spinner';
import ConfirmationService from '@/Services/ConfirmationService';
import { useToastService } from '@/Plugins/toast-service';
import FertilizationService from '../../../../Services/FertilizationService';
import { trans } from 'laravel-vue-i18n';
import RecordsTableHeader from '../../../../Components/RecordsTableHeader.vue';
import Calendar from 'primevue/calendar';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Table',
    props: {
        orchard_id: {
            type: Number,
            required: true,
        },
        plot_id: Number,
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const fertilizationService = new FertilizationService();
        const emitter = useMitt();
        const spinner = useSpinner();
        const confirmationService = new ConfirmationService();
        const toast = useToastService();
        const records = ref([]);
        const selectedRecords = ref([]);
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            date: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
            },
        });
        const globalFilterFields = ['code'];
        const fields = [
            { field: 'nitrogen', unit: 'kg/ha' },
            { field: 'phosphorus', unit: 'kg/ha' },
            { field: 'potassium', unit: 'kg/ha' },
            { field: 'calcium', unit: 'kg/ha' },
            { field: 'magnesium', unit: 'kg/ha' },
            { field: 'sulfur', unit: 'kg/ha' },
            { field: 'iron', unit: 'kg/ha' },
            { field: 'manganese', unit: 'kg/ha' },
            { field: 'zinc', unit: 'kg/ha' },
            { field: 'copper', unit: 'kg/ha' },
            { field: 'boron', unit: 'kg/ha' },
        ];
        fields.forEach((field) => {
            filters.value[field.field] = {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
            };
        });
        const editItem = (data) => emitter.emit('open-fertilization-form', data);
        const reloadRecords = () => {
            spinner.show();
            fertilizationService
                .getAll(props.orchard_id, props.plot_id)
                .then((irrigations) => {
                records.value = irrigations;
            })
                .finally(() => spinner.hide());
        };
        const deleteSelected = () => {
            const ids = selectedRecords.value.map((i) => i.id);
            confirmationService.confirmDeleteMultiple(selectedRecords.value.length, () => {
                spinner.show();
                fertilizationService
                    .destroy(ids)
                    .then(() => {
                    emitter.emit('irrigation-saved');
                    toast.deleteSuccess();
                })
                    .finally(() => spinner.hide());
            }, () => { });
        };
        reloadRecords();
        emitter.on('fertilization-saved', () => reloadRecords());
        const __returned__ = { props, fertilizationService, emitter, spinner, confirmationService, toast, records, selectedRecords, filters, globalFilterFields, fields, editItem, reloadRecords, deleteSelected, get Button() { return Button; }, DataTable, get Column() { return Column; }, get formatISODate() { return formatISODate; }, get trans() { return trans; }, RecordsTableHeader, get Calendar() { return Calendar; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
